import { styled } from "styled-components";

export const Header = styled.header`
	display: flex;
	font-size: 14px;
	justify-content: space-between;

	.type {
		color: #333333;
		font-weight: 500;
		font-size: 18px;
	}

	select {
		background: rgba(0, 103, 112, 0.03);
		box-shadow: 0px 4px 4px rgba(0, 103, 112, 0.05);
		border-radius: 10px;
		padding: 2px;
		color: #006770;
		border: none;
		outline: none;
	}
`;

export const CardStyles = styled.div`
	padding: 15px;
	max-height: 35rem;
	width: auto;
	background-color: #ffffff;
	box-sizing: border-box;
	border: 1px solid #b8c8cf;
	border-radius: 20px;
	box-shadow: 0px 15px 50px rgba(0, 103, 112, 0.05);

	header {
		display: flex;
		justify-content: space-between;
		padding: 0;
		margin-bottom: 5px;
	}
`;

export const UsersTrackerContent = styled.div`
	margin-top: 10px;
	display: flex;
	flex-direction: column;
	gap: 20px;

	.totalUsers {
		font-size: 16px;
		color: #00ae26;
		font-weight: 600;
	}

	.mainContent {
		display: flex;
		justify-content: space-between;

		.numbers {
			color: #006770;
			font-size: 16px;
			font-weight: 600;
		}

		.rateWrapper {
			display: flex;
			gap: 0.25rem;
		}

		.rate {
			color: #999999;
			font-size: 18px;
		}
	}

	.progressBar {
		width: 100%;
		padding: 3px;
		background-color: #006770;
		border-radius: 5px;
		height: 5px;
	}
`;

export const DoughnutWrapper = styled.div`
	height: 150px;
	margin-top: 10px;
	position: relative;
	box-sizing: border-box;

	.text {
		position: absolute;
		left: 3.8rem;
		top: 3.6rem;
		text-align: center;
		.amount {
			font-size: 1.6rem;
			font-weight: 600;
		}
		.percentile {
			font-size: 1rem;
		}
	}
`;

export const UserCardStyles = styled.div`
	box-sizing: border-box;
	padding: 15px;
	background-color: #ffffff;
	border: 1px solid #b8c8cf;
	box-shadow: 0px 15px 50px rgba(0, 103, 112, 0.05);
	border-radius: 20px;
	min-height: 250px;
	display: flex;
	flex-direction: column;
	gap: 25px;

	.title {
		color: #333333;
		font-weight: 500;
	}

	.details {
		display: flex;
		justify-content: space-between;

		.email {
			font-size: 12px;
			color: #999999;
		}

		section {
			display: flex;
			gap: 5px;
			align-items: center;

			.name {
				font-size: 15px;
				color: #333333;
				font-weight: 500;
			}

			.email {
				font-size: 12px;
				color: #999999;
			}
		}
	}
`;

export const LabelWrapper = styled.div`
	margin-top: 10px;
	/* border: 1px solid red; */

	.firstSection {
		display: flex;
		gap: 10px;
		font-size: 14px;
		margin-top: 1rem;

		.firstcolor {
			border-radius: 50%;
			padding: 9px;
			background-color: ${(props) => props.firstcolor};
			align-self: flex-start;
			border-radius: 8px;
		}

		.secondcolor {
			border-radius: 50%;
			padding: 9px;
			background-color: ${(props) => props.secondcolor};
			align-self: flex-start;
			border-radius: 8px;
		}

		.firstDetails {
			font-size: 0.9rem;

			.header {
				color: #333333;
				font-size: 1rem;
				font-weight: 600;
			}
		}
	}
`;

export const Content = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 10px 0;
`;

export const ProgressBarStyle = styled.div`
	.container {
		width: 100%;
		background-color: #e5e5e5;
		border-radius: 5px;
		height: 5px;

		.completed {
			background-color: ${(props) => props.color};
			height: 5px;
			border-radius: 5px;
			padding: 2px;
			width: ${(props) => props.width}%;
		}
	}
`;
